import styled from 'styled-components/macro';

/**
 * Content is a component in which you place the main content for your route
 * The content of this component will be positioned in the right place with
 * flexbox, also ensuring we have 3 seperate z-index stacks (header/content/footer)
 * in which we can use z-index more freely.
 */
const Content = styled.div.attrs({
  role: 'main',
})`
  position: relative;
  z-index: 1;
  flex: auto;
  display: flex;
  flex-flow: column nowrap;
`;

/**
 * @component
 */
export default Content;
